import "core-js/modules/es7.symbol.async-iterator";
import "core-js/modules/es6.symbol";
import "core-js/modules/es6.array.from";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.string.iterator";
import "core-js/modules/es6.set";
import "core-js/modules/es6.regexp.replace";
import _classCallCheck from "/Users/gongwu.nie/Github/react-base-table/website/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _possibleConstructorReturn from "/Users/gongwu.nie/Github/react-base-table/website/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/gongwu.nie/Github/react-base-table/website/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _assertThisInitialized from "/Users/gongwu.nie/Github/react-base-table/website/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _createClass from "/Users/gongwu.nie/Github/react-base-table/website/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/Users/gongwu.nie/Github/react-base-table/website/node_modules/@babel/runtime/helpers/esm/inherits";
import { IdentifierRole, isTopLevelDeclaration } from "../parser/tokenizer";
import Transformer from "./Transformer";

var ReactHotLoaderTransformer =
/*#__PURE__*/
function (_Transformer) {
  _inherits(ReactHotLoaderTransformer, _Transformer);

  _createClass(ReactHotLoaderTransformer, [{
    key: "__init",
    value: function __init() {
      this.extractedDefaultExportName = null;
    }
  }]);

  function ReactHotLoaderTransformer(tokens, filePath) {
    var _this;

    _classCallCheck(this, ReactHotLoaderTransformer);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ReactHotLoaderTransformer).call(this));
    _this.tokens = tokens;
    _this.filePath = filePath;

    ReactHotLoaderTransformer.prototype.__init.call(_assertThisInitialized(_this));

    ;
    return _this;
  }

  _createClass(ReactHotLoaderTransformer, [{
    key: "setExtractedDefaultExportName",
    value: function setExtractedDefaultExportName(extractedDefaultExportName) {
      this.extractedDefaultExportName = extractedDefaultExportName;
    }
  }, {
    key: "getPrefixCode",
    value: function getPrefixCode() {
      return "\n      (function () {\n        var enterModule = require('react-hot-loader').enterModule;\n        enterModule && enterModule(module);\n      })();".replace(/\s+/g, " ").trim();
    }
  }, {
    key: "getSuffixCode",
    value: function getSuffixCode() {
      var _this2 = this;

      var topLevelNames = new Set();
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = this.tokens.tokens[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var token = _step.value;

          if (!token.isType && isTopLevelDeclaration(token) && token.identifierRole !== IdentifierRole.ImportDeclaration) {
            topLevelNames.add(this.tokens.identifierNameForToken(token));
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return != null) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      var namesToRegister = Array.from(topLevelNames).map(function (name) {
        return {
          variableName: name,
          uniqueLocalName: name
        };
      });

      if (this.extractedDefaultExportName) {
        namesToRegister.push({
          variableName: this.extractedDefaultExportName,
          uniqueLocalName: "default"
        });
      }

      return "\n;(function () {\n  var reactHotLoader = require('react-hot-loader').default;\n  var leaveModule = require('react-hot-loader').leaveModule;\n  if (!reactHotLoader) {\n    return;\n  }\n".concat(namesToRegister.map(function (_ref) {
        var variableName = _ref.variableName,
            uniqueLocalName = _ref.uniqueLocalName;
        return "  reactHotLoader.register(".concat(variableName, ", \"").concat(uniqueLocalName, "\", \"").concat(_this2.filePath, "\");");
      }).join("\n"), "\n  leaveModule(module);\n})();");
    }
  }, {
    key: "process",
    value: function process() {
      return false;
    }
  }]);

  return ReactHotLoaderTransformer;
}(Transformer);

export { ReactHotLoaderTransformer as default };